export class ParametrosKit {
  id: number;
  tipoParametro: number;
  produtoInversor?: number;
  produtoInversorDescricao: string;
  produtoParametro?: number;
  produtoParametroDescricao: string;
  qtd?: number;
  multiplo?: number;
  potPainel?: number;
  qtMin?: number;
  qtMax?: number;
  total?: number;
  tipoLigacao?:number;
  manual: boolean;
  tipoInversor?: number;
  replicarMultiplos: boolean;
}


